import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      marginTop: Spacings.s16,
    },
    skeletonBlock: {
      height: 136,
      width: '100%',
      marginBottom: Spacings.s8,
    },
  },
  {
    name: 'font-skeleton',
  },
);

export default useStyles;
